"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _antd = require("antd");

var _LinkSelector = _interopRequireDefault(require("./LinkSelector"));

var _MediaLibrary = _interopRequireDefault(require("./MediaLibrary"));

var _redux = require("../redux");

var _theme = require("../theme");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var JoditEditor = function JoditEditor() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
};

var HTMLEditor = function HTMLEditor(props) {
  var _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? '' : _props$defaultValue,
      onChange = props.onChange;
  var dispatch = (0, _redux.useAppDispatch)();
  var editorRef = (0, _react.useRef)(null);

  var _ref2 = (0, _react.useState)(''),
      _ref3 = _slicedToArray(_ref2, 2),
      modal = _ref3[0],
      setModal = _ref3[1];

  var _ref4 = (0, _react.useState)({}),
      _ref5 = _slicedToArray(_ref4, 2),
      link = _ref5[0],
      setLink = _ref5[1];

  var _ref6 = (0, _react.useState)({}),
      _ref7 = _slicedToArray(_ref6, 2),
      editor = _ref7[0],
      setEditor = _ref7[1];

  var _ref8 = (0, _react.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      editorFullscreen = _ref9[0],
      setEditorFullscreen = _ref9[1];

  var _ref10 = (0, _react.useState)(false),
      _ref11 = _slicedToArray(_ref10, 2),
      loaded = _ref11[0],
      setLoaded = _ref11[1];

  var _ref12 = (0, _react.useState)(defaultValue),
      _ref13 = _slicedToArray(_ref12, 2),
      content = _ref13[0],
      setContent = _ref13[1];

  var _ref14 = (0, _react.useState)(0),
      _ref15 = _slicedToArray(_ref14, 2),
      index = _ref15[0],
      setIndex = _ref15[1];

  var _ref16 = (0, _react.useState)(1),
      _ref17 = _slicedToArray(_ref16, 2),
      mode = _ref17[0],
      setMode = _ref17[1]; // We can't trigger the onChange callback within the useMemo function because this resets other fields
  // We're using an index instead of the content which should make the comparison more efficient


  (0, _react.useEffect)(function () {
    // The editor fires one onChange event on load if no content is given and two events if the textfield already has a default value.
    // As a result the postHasChanged / siteHasChanged flags will be true so the user won't be able to navigate away, even though nothing has changed.
    // That's why we add a check for the index and default value here.
    if (defaultValue && index > 1 || !defaultValue && index > 0) {
      onChange(content);
    }
  }, [index]); // Jodit module loader on component mount (SSR fix)

  (0, _react.useEffect)(function () {
    JoditEditor = require('jodit-react').default;
    setLoaded(true);
  }, []); // Disable links in sidebar to allow for relative links (not catched by Jodit)

  (0, _react.useEffect)(function () {
    var _document$querySelect;

    var anchors = ((_document$querySelect = document.querySelector('#jam-cms-sidebar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelectorAll('a')) || [];

    for (var i = 0; i < anchors.length; i++) {
      anchors[i].onclick = function (e) {
        e.preventDefault();
      };
    }
  }, [defaultValue, loaded]);

  var handleSetFullscreen = function handleSetFullscreen(value) {
    // We are updating the global and local state for fullscreen. This way we prevent opening the wrong editor (in case there is more than one).
    dispatch(_redux.uiActions.updateEditorSettings({
      fullscreen: value
    }));
    setEditorFullscreen(value);
  };

  var handleSelectImage = function handleSelectImage(image) {
    var html = "<img src=\"".concat(image.url, "\" alt=\"").concat(image.altText, "\" class=\"wp-image-").concat(image.id, "\" />");
    editor.s.insertHTML(html);
    setModal('');
    setEditor({});
  };

  var handleSelectLink = function handleSelectLink(link) {
    var target = '';

    if (link.target) {
      target = "target=\"".concat(link.target, "\"");
    }

    var html = "<a href=\"".concat(link.url, "\" ").concat(target, ">").concat(link.title, "</a>");
    editor.s.insertHTML(html);
    setModal('');
    setLink(null);
    setEditor(null);
  }; // We use the useMemo hook here to fix some issues where the editor gets resetted because of global state changes


  var jodit = (0, _react.useMemo)(function () {
    // Jodit Playground: https://xdsoft.net/jodit/play.html
    var config = {
      // Options: http://rmamuzic.rs/node_modules/jodit/examples/index.html
      toolbarDisableStickyForMobile: false,
      useSearch: false,
      minHeight: 300,
      spellcheck: false,
      showCharsCounter: false,
      showXPathInStatusbar: false,
      toolbarButtonSize: 'small',
      defaultMode: mode,
      placeholder: 'Write something...',
      // Clean: https://xdsoft.net/jodit/doc/options/cleanHTML/
      cleanHTML: {
        fillEmptyParagraph: false
      },
      // Controls: https://xdsoft.net/jodit/doc/options/controls/
      controls: {
        // We store the fullscreen state in the global state to avoid certain responsiveness bugs with the popup menu
        fullsize: {
          exec: function exec(e) {
            handleSetFullscreen(!editorFullscreen);
          },
          update: function update(e) {
            var t = e.j,
                n = editorFullscreen ? 'shrink' : 'fullsize';
            e.state.activated = editorFullscreen, t.o.textIcons ? e.state.text = n : e.state.icon.name = n;
          },
          tooltip: 'Open editor in fullsize',
          mode: 3
        },
        source: {
          mode: 3,
          exec: function exec(e) {
            setMode(function (mode) {
              return mode === 1 ? 2 : 1;
            });
          },
          isActive: 'function(e){return e.getRealMode()===o.MODE_SOURCE}',
          tooltip: 'Change mode'
        },
        link: {
          isActive: 'function(e){var t=e.s.current();return Boolean(t&&i.Dom.closest(t,"a",e.editor))}',
          popup: function popup(e, t, n, r) {
            var _e$s, _e$s$current;

            setEditor(e);
            setLink({
              title: ((_e$s = e.s) === null || _e$s === void 0 ? void 0 : _e$s.range.cloneContents().textContent) || ((_e$s$current = e.s.current()) === null || _e$s$current === void 0 ? void 0 : _e$s$current.textContent) || '',
              url: t && typeof t.getAttribute === 'function' ? t.getAttribute('href') : '',
              target: t ? t.target : ''
            });
            setModal('link');
            return;
          },
          tags: ['a'],
          tooltip: 'Insert link'
        }
      },
      disablePlugins: 'print,preview,table-keyboard-navigation,image-processor,xpath,stat,search,limit,font,color,paste-storage,about,video,image,error-messages,copy-format,class-span',
      buttonsXS: ['link', 'align', 'bold', 'paragraph', 'fullsize', 'dots'],
      extraButtons: [{
        name: 'jamImage',
        tooltip: 'Image',
        iconURL: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNzkyIDE3OTIiIGNsYXNzPSJqb2RpdC1pY29uX2ltYWdlIGpvZGl0LWljb24iPiA8cGF0aCBkPSJNNTc2IDU3NnEwIDgwLTU2IDEzNnQtMTM2IDU2LTEzNi01Ni01Ni0xMzYgNTYtMTM2IDEzNi01NiAxMzYgNTYgNTYgMTM2em0xMDI0IDM4NHY0NDhoLTE0MDh2LTE5MmwzMjAtMzIwIDE2MCAxNjAgNTEyLTUxMnptOTYtNzA0aC0xNjAwcS0xMyAwLTIyLjUgOS41dC05LjUgMjIuNXYxMjE2cTAgMTMgOS41IDIyLjV0MjIuNSA5LjVoMTYwMHExMyAwIDIyLjUtOS41dDkuNS0yMi41di0xMjE2cTAtMTMtOS41LTIyLjV0LTIyLjUtOS41em0xNjAgMzJ2MTIxNnEwIDY2LTQ3IDExM3QtMTEzIDQ3aC0xNjAwcS02NiAwLTExMy00N3QtNDctMTEzdi0xMjE2cTAtNjYgNDctMTEzdDExMy00N2gxNjAwcTY2IDAgMTEzIDQ3dDQ3IDExM3oiPjwvcGF0aD4gPC9zdmc+',
        exec: function exec(e) {
          setEditor(e);
          setModal('image');
        }
      }]
    };
    return loaded && /*#__PURE__*/_react.default.createElement(JoditEditor, {
      ref: editorRef,
      value: defaultValue,
      config: config,
      onChange: function onChange(newContent) {
        setContent(newContent);
        setIndex(function (index) {
          return index + 1;
        });
      }
    });
  }, [loaded, editorFullscreen, mode]);
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: editorFullscreen ? 'jodit-fullscreen' : '',
    fullscreen: editorFullscreen
  }, /*#__PURE__*/_react.default.createElement(Global, null), jodit, /*#__PURE__*/_react.default.createElement(_antd.Modal, {
    title: modal === 'image' ? 'Media' : 'Link',
    visible: !!modal,
    onCancel: function onCancel() {
      setModal('');
      setLink(null);
    },
    width: modal === 'image' || modal === 'editor' ? 1024 : 500,
    footer: null,
    destroyOnClose: true
  }, modal === 'image' && /*#__PURE__*/_react.default.createElement(_MediaLibrary.default, {
    onSelect: handleSelectImage,
    allow: ['image']
  }), modal === 'link' && /*#__PURE__*/_react.default.createElement(_LinkSelector.default, {
    onChange: handleSelectLink,
    value: link
  })));
};

var Container = (0, _styledComponents.default)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .jodit-wysiwyg_mode,\n  .jodit-source__mode {\n    ", "\n  }\n\n  .jodit-container:not(.jodit_inline) {\n    border: none;\n  }\n\n  .jodit-container:not(.jodit_inline) .jodit-wysiwyg {\n    padding: 8px;\n    border-left: 1px solid ", ";\n    border-right: 1px solid ", ";\n    border-bottom: 1px solid ", ";\n  }\n\n  .jodit-toolbar__box:not(:empty) {\n    width: 100% !important;\n    border: 1px solid ", ";\n    border-radius: 4px;\n    background: ", ";\n  }\n\n  .jodit-toolbar-editor-collection_mode_horizontal:after {\n    background: ", ";\n  }\n\n  .jodit-wysiwyg {\n    h1 {\n      font-size: 1.5rem;\n    }\n\n    h2 {\n      font-size: 1.4rem;\n    }\n\n    h3 {\n      font-size: 1.3rem;\n    }\n\n    h4 {\n      font-size: 1.2rem;\n    }\n\n    ul,\n    ol {\n      padding-left: 20px;\n    }\n\n    ul {\n      list-style-type: disc;\n    }\n\n    ol {\n      list-style-type: decimal;\n    }\n\n    a {\n      text-decoration: underline;\n    }\n  }\n\n  .jodit-ui-group__jamImage {\n    order: -2;\n  }\n\n  .jodit-ui-group__jamLink {\n    order: -1;\n  }\n"])), function (_ref) {
  var fullscreen = _ref.fullscreen;
  return fullscreen ? (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n            position: fixed;\n            left: 0;\n            top: 0;\n            width: 100% !important;\n            height: 100% !important;\n            z-index: 1000;\n\n            .jodit-wysiwyg {\n              padding: 20px !important;\n            }\n\n            .jodit-placeholder {\n              padding: 20px;\n            }\n\n            .jodit-workplace {\n              max-width: 600px;\n              margin: 0 auto;\n            }\n          "]))) : (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n            .jodit-resizer {\n              display: none;\n            }\n          "])));
}, _theme.colors.tertiary, _theme.colors.tertiary, _theme.colors.tertiary, _theme.colors.tertiary, _theme.colors.secondaryContrast, _theme.colors.secondaryContrast);
var Global = (0, _styledComponents.createGlobalStyle)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n\n  .jodit-container{\n    background: transparent !important;\n  }\n\n  .jodit-workplace {\n    background: #fff;\n  }\n  \n  .jodit-fullscreen {\n    .jodit-toolbar-editor-collection {\n      flex-direction: row;\n      justify-content: center;\n      flex-wrap: wrap;\n    }\n\n    .jodit-container:not(.jodit_inline){\n      background: ", " !important;\n    }\n  }\n\n  .jodit_fullsize-box_true.jodit_fullsize-box_true {\n    z-index: 1000!important;\n  }\n\n  .jodit-popup-container, .jodit-dialog__panel {\n\n    // Style popup\n    .jodit-popup{\n      border: 1px solid ", ";\n      border-radius: 4px;\n      box-shadow: none;\n      overflow: hidden;\n    }\n\n    .jodit-toolbar-editor-collection_mode_horizontal:after {\n      background: ", ";\n    }\n    \n    // Remove icons in link menu\n    .jodit-toolbar-button_brush,\n    .jodit-toolbar-button_file {\n      display: none;\n    }\n\n    // Remove unlink button from link popup (doesn't work)\n    .jodit-ui-button_unlink{\n      display: none;\n    }\n\n    .jodit-popup__content{\n      padding: 0;\n      max-height: 400px;\n      background: ", ";\n\n      .jodit-toolbar-button_link{\n        display: none;\n      }\n    }\n\n    .jodit-ui-input__label, label {\n      margin-bottom: 2px !important;\n      font-size: 10px;\n      text-transform: uppercase;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      color: ", ";\n    }\n\n    .jodit-ui-block {\n      margin-top: 20px;\n      margin-bottom: 20px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    .jodit-ui-button_status_primary, .jodit-ui-button_ok {\n      background-color: #2a88fb;\n      color: #fff;\n\n      &:hover {\n        background-color: #0069d9 !important;\n        color: #fff;\n      }\n\n      .jodit-ui-button__icon {\n        svg {\n          path {\n            fill: #fff;\n          }\n        }\n      }\n    }\n\n    .jodit-input_group{\n      margin-top: 0 !important;\n    }\n\n    .jodit-ui-form {\n      padding: 10px;\n    }\n\n    .jodit-toolbar-button, .jodit-toolbar-button__button {\n      min-height: auto !important;\n    }\n\n    .jodit-toolbar-button__button {\n      padding: 2px 6px;\n    }\n  }\n"])), _theme.colors.secondaryContrast, _theme.colors.tertiary, _theme.colors.secondaryContrast, _theme.colors.secondaryContrast, _theme.colors.secondary);
var _default = HTMLEditor;
exports.default = _default;